import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const mediaLibrary = {
  fetchMediaLibrary: lazyModuleMethod(
    () => import('./fetchMediaLibrary'),
    'default'
  ),
  addImageMediaLibrary: lazyModuleMethod(
    () => import('./addImageMediaLibrary'),
    'default'
  ),
  deleteImageMediaLibrary: lazyModuleMethod(
    () => import('./deleteImageMediaLibrary'),
    'default'
  ),
}
